import React from 'react';
import SummaryWithChart from "../section/SummaryWithChart";
import Summary from "../section/Summary";
import '../common.css';
import RecommendTable from "../table/RecommendTable";
import InformationTable from "../table/InformationTable";
import RedirectMenu from "../section/RedirectMenu";
import HighSkill from "../section/HighSkill";
import LowSkill from "../section/LowSkill";
import Comparison from "../section/Comparison";

interface AssessmentResultsProps {
    title: string,
    questions?: question[],
    groups: group[],
    hightSkills?: group[];
    lowSkills?: group[];
    comparison?: group[];
    currentLevel?: group;
    threeYearAgo?: group;
    feedback?: string
    templateAnswerResult?: string
    activeTemplate?: boolean
    answerTime?: string
    feedbackAssisstant: Map<string, string>
}

interface question {
    title: string,
    answer: string,
    type: number
}

interface group {
    groupTitle: string,
    totalPoint: number,
    totalQuestion: number,
    advice: string,
    avgPoint: number,
    stdevpPoint: number,
    deviation: number,
    exposition: string,
    isLowSkill?: string,
    acronym?: string
}

const AssessmentResults: React.FC<{ data: AssessmentResultsProps }> = ({ data }) => {
    return (
        data && <div className="container acf-wrap">
            <div style={{ maxWidth: '1000px', margin: '0 auto', fontFamily: '源ノ角ゴシック JP'}}>
                <h1 className={'p-5'} style={{ textAlign: 'center', fontSize: '25px', fontWeight: 'bold', color:'#232323' }}>リスキリングアセスメント結果</h1>
                <InformationTable data={data}/>

                <RedirectMenu defaultTemplate={true}/>

                <SummaryWithChart data={data} defaultTemplate={true}/>

                <HighSkill data={data} defaultTemplate={true}/>

                <LowSkill data={data} defaultTemplate={true}/>

                <Comparison data={data} defaultTemplate={true}/>

                <Summary data={data.feedbackAssisstant.get('4') != null ? data.feedbackAssisstant.get('4') : ''} defaultTemplate={true}/>

                <RecommendTable defaultTemplate={true}/>
            </div>
        </div>
    );
}

export default AssessmentResults;
